import type { TravelFormProps } from '@/features/travel-form/travel-form';
import type { TravelFormV1Attributes } from '@/features/travel-form/travel-form-v1/travel-form-v1-type';

import { HtmlTextWrapper, ResponsiveImage } from '@/core/features';
import color from '@/core/features/styles/color';
import TravelForm from '@/features/travel-form/travel-form';

type TravelFormV1Props = {
    banner: TravelFormV1Attributes['banner'];
} & TravelFormProps;

export default function TravelFormV1(props: TravelFormV1Props) {
    const { banner } = props;

    if (!banner?.title && banner?.htmlTitle) {
        return (
            <div
                className={'flex flex-col gap-20 pt-20 pb-4 bg-white'}
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ paddingBottom: 4 }}
            >
                <h1 className={'flex flex-col justify-center items-start gap-16 z-1'}>
                    <HtmlTextWrapper
                        className={'text-24'}
                        htmlText={banner.htmlTitle}
                    />
                </h1>
                {banner.subtitle && <span className={'text-18'}>{banner.subtitle}</span>}
                <TravelFormWrapper {...props} />
            </div>
        );
    }

    if (!banner || !banner.image) {
        return (
            <div className={'full-width'}>
                <TravelFormWrapper {...props} />
            </div>
        );
    }

    return (
        <div className={'full-width'}>
            <div
                className={'w-full'}
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ padding: '60px 20px 0 20px' }}
            >
                <div className={'absolute top-0 left-0 right-0'}>
                    <ResponsiveImage
                        alt={banner.image.imageUrl}
                        fetchPriority={'high'}
                        height={280}
                        layoutWidth={100}
                        preload={true}
                        url={banner.image.imageUrl}
                    />
                    <div
                        className={'absolute h-full inset-0 z-1'}
                        // eslint-disable-next-line no-inline-styles/no-inline-styles
                        style={{ backgroundColor: color('check24Blue-04') }}
                    />
                </div>
                <div className={'flex flex-col gap-16 h-full'}>
                    <div className={'flex flex-col justify-center items-start gap-16 z-1'}>
                        {banner.title && <h1 className={'text-24 text-white font-bold'}>{banner.title}</h1>}
                        {banner.subtitle && (
                            <span className={'text-18 text-white wrap-break-word'}>{banner.subtitle}</span>
                        )}
                    </div>
                    <TravelFormWrapper {...props} />
                </div>
            </div>
        </div>
    );
}

const TravelFormWrapper = ({
    activityRequestTarget,
    airportsRequestTarget,
    dateRequestTarget,
    destinationChangeRequestTarget,
    destinationRequestTarget,
    formConfiguration,
    onOverlayClose,
    onOverlayCtaClick,
    overlayType,
    travelForm,
}: TravelFormProps) => {
    return (
        <TravelForm
            activityRequestTarget={activityRequestTarget}
            airportsRequestTarget={airportsRequestTarget}
            dateRequestTarget={dateRequestTarget}
            destinationChangeRequestTarget={destinationChangeRequestTarget}
            destinationRequestTarget={destinationRequestTarget}
            formConfiguration={formConfiguration}
            noBackground={true}
            onOverlayClose={onOverlayClose}
            onOverlayCtaClick={onOverlayCtaClick}
            overlayType={overlayType}
            travelForm={travelForm}
        />
    );
};
